const asyncActionType = type => ({
  pending: `${type}/PENDING`,
  success: `${type}/SUCCESS`,
  error: `${type}/ERROR`
});

export const TASKS_LIST = asyncActionType('aerosimple/tasks/TASKS_LIST');
export const TASK_DETAILS = asyncActionType('aerosimple/tasks/TASK_DETAILS');
export const TOGGLE_COMPLETE_TASK = asyncActionType('aerosimple/tasks/TOGGLE_COMPLETE_TASK');
export const UPDATE_TASK = asyncActionType('aerosimple/tasks/UPDATE_TASK');

export const RESET_COMPLETE_TASK = 'aerosimple/tasks/RESET_COMPLETE_TASK';
